import {createSlice, PayloadAction} from '@reduxjs/toolkit';

type AuthState = {
  email?: string;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  userId?: string;
  userName?: string;
  groupId?: string | number | null;
  permissions?: string[];
};

const initialState: AuthState = {
  accessToken: null,
  refreshToken: null,
  isAuthenticated: false,
  userId: undefined,
  userName: undefined,
  email: undefined,
  groupId: undefined,
  permissions: undefined,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setTokens: (
      state,
      action: PayloadAction<{
        accessToken: string;
        refreshToken: string;
        userId?: string;
        userName?: string;
        email?: string;
        groupId?: string | number | null;
        permissions?: string[];
      }>
    ) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.userId = action.payload.userId;
      state.userName = action.payload.userName;
      state.email = action.payload.email;
      state.groupId = action.payload.groupId;
      state.permissions = action.payload.permissions;
      state.isAuthenticated = true;
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
      state.isAuthenticated = true;
    },
    setUserInfo: (
      state,
      action: PayloadAction<{userId?: string; userName?: string; email?: string; groupId?: string | number | null; permissions?: string[]}>
    ) => {
      state.userId = action.payload.userId;
      state.email = action.payload.email;
      state.groupId = action.payload.groupId;
      state.permissions = action.payload.permissions;
    },
    clearAuth: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      state.userId = undefined;
      state.userName = undefined;
      state.email = undefined;
      state.groupId = undefined;
      state.permissions = undefined;
    },
  },
});

export const {setTokens, setAccessToken, setUserInfo, clearAuth} = authSlice.actions;

export {authSlice};
